import MapService from './MapService'

export default MapService
export { mapServices } from './MapService'
